import Vue from 'vue';
import { mapState, mapMutations } from 'vuex';
import { navigateWindow } from '@/router/routerUtils';
export default Vue.extend({
    props: {
        image: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            linkRedirect: '',
            checkboxValue: false,
        };
    },
    methods: {
        ...mapMutations('alcoholModule', ['setModalShow', 'setTimestamp']),
        alcoholShowModal(linkPage) {
            this.linkRedirect = linkPage;
            if (this.canShow()) {
                this.$bvModal.show('alcoholmodal');
            }
            else {
                this.redirect();
            }
        },
        redirect() {
            if (this.canShow() && this.checkboxValue === true) {
                this.setModalShow(true);
                this.setTimestamp(Date.now());
            }
            this.$bvModal.hide('alcoholmodal');
            navigateWindow(this.linkRedirect);
        },
        canShow() {
            if (this.modalShow !== true) {
                return true;
            }
            var timeTmp = new Date(this.timestamp);
            timeTmp.setTime(timeTmp.getTime() + 24 * 60 * 60 * 1000);
            if (Date.now() > timeTmp.getTime()) {
                return true;
            }
            return false;
        },
        attachClickToShowModal() {
            document.addEventListener('click', this.onAlcoholLink, true);
        },
        onAlcoholLink(event) {
            if (event.defaultPrevented || event.button !== 0 || event.ctrlKey ||
                event.metaKey || event.shiftKey || event.altKey)
                return;
            const target = event.target;
            const element = target instanceof Element ? target : target?.parentElement;
            const anchor = element?.closest('a.showAlcoholModal[href]');
            if (!anchor || anchor.hasAttribute('download') ||
                (anchor.target && anchor.target !== '_self'))
                return;
            event.preventDefault();
            this.alcoholShowModal(anchor.href);
        },
    },
    computed: {
        ...mapState('alcoholModule', ['modalShow', 'timestamp']),
    },
    created() {
        this.$root.$refs.AlcoholAlert = this;
    },
    mounted() {
        this.attachClickToShowModal();
    },
    beforeDestroy() {
        document.removeEventListener('click', this.onAlcoholLink, true);
    },
});
